import type { LotteryRound } from '../services/lotteryService'

export interface YeekeeResultData {
  sumTotal: string | number
  position16Number?: string
  finalNumber?: string
  threeDigitTop: string
  twoDigitTop?: string
  twoDigitDown?: string
  threeDigitBottom?: string
  totalShots?: number
  shotsUsedInResult?: number
  calculatedAt?: string
}

export interface YeekeeShotRow {
  _id?: string
  number: string
  username?: string
  displayPhoneNumber?: string
  shooterType?: string
  shotAt: string
  position?: number
}

export function getYeekeeRoundNumber(round?: LotteryRound | null): string {
  return round?.roundNumber?.split('-')[2] || '-'
}

export function getYeekeeResultFromRound(round?: LotteryRound | null): YeekeeResultData | undefined {
  return (round?.yeekee as { result?: YeekeeResultData } | undefined)?.result
}

export function maskYeekeeMember(raw: string): string {
  const s = String(raw || '').trim()
  if (!s || s.length < 4) return s || 'สมาชิก'
  if (/^\d+$/.test(s)) {
    if (s.length >= 10) return s.slice(0, 3) + 'xxxxxx' + s.slice(-1)
    return s.slice(0, 2) + 'xxxxx' + s.slice(-1)
  }
  if (s.length <= 6) return s.slice(0, 1) + 'xxx' + s.slice(-1)
  return s.slice(0, 2) + 'xxxxx' + s.slice(-3)
}

function botDisplayNameFallback(id: string): string {
  const letters = 'abcdefghijklmnopqrstuvwxyz'
  let n = 0
  for (let i = 0; i < (id || '').length; i++) n = (n * 31 + (id.charCodeAt(i) || 0)) >>> 0
  const r = () => {
    n = (n * 1103515245 + 12345) >>> 0
    return n
  }
  const p = () => letters[r() % 26]
  return p() + p() + 'xxxxx' + p() + p() + String(r() % 10)
}

export function getYeekeeShotMemberName(shot: YeekeeShotRow, index: number): string {
  const isBot = String(shot.shooterType) === 'bot'
  if (isBot) {
    return shot.username && shot.username.includes('xxxxx')
      ? shot.username
      : botDisplayNameFallback(shot._id != null ? String(shot._id) : String(index))
  }
  if (shot.username) return maskYeekeeMember(shot.username)
  if (shot.displayPhoneNumber) return maskYeekeeMember(shot.displayPhoneNumber)
  return 'สมาชิก'
}

// Label the round by betEndTime (close/draw time) to match slip pages.
export function formatYeekeeOpenTime(round?: LotteryRound | null): string {
  if (!round?.betEndTime) return ''
  return new Date(round.betEndTime).toLocaleString('th-TH', {
    timeZone: 'Asia/Bangkok',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatYeekeeCloseTime(round?: LotteryRound | null): string {
  if (!round?.betEndTime) return ''
  return new Date(round.betEndTime).toLocaleString('th-TH', {
    timeZone: 'Asia/Bangkok',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatYeekeeShotTime(shotAt?: string): string {
  if (!shotAt) return '-'
  return new Date(shotAt).toLocaleTimeString('th-TH', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}
